import AnatomyV2Age from '~/pages/anatomyV2/age/libs/components/AnatomyV2Age'
import { TPageProps } from '~/shared/types/commonTypes'

const AgeAnatomyV2 = (props: TPageProps) => <AnatomyV2Age {...props} />

export default AgeAnatomyV2
